"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmSceneVertical
 * @author xlongjiang
 * @created 2025-11-03 08:07:06
 */
const TabPanel = _tpmProductIntl.Tab.TabPanel;

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmSceneVerticalData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$tabList = _ref.tabList,
    tabList = _ref$tabList === void 0 ? [] : _ref$tabList;
  const handleTabList = tabList.map((item, index1) => {
    const _item$text = item.text,
      text = _item$text === void 0 ? '' : _item$text,
      _item$itemList = item.itemList,
      itemList = _item$itemList === void 0 ? [] : _item$itemList,
      _item$btnList = item.btnList,
      btnList = _item$btnList === void 0 ? [] : _item$btnList;
    const handleItems = itemList.map((item, index) => {
      const _item$tabTitle = item.tabTitle,
        tabTitle = _item$tabTitle === void 0 ? '' : _item$tabTitle,
        _item$tabDesc = item.tabDesc,
        tabDesc = _item$tabDesc === void 0 ? '' : _item$tabDesc,
        _item$title = item.title,
        title = _item$title === void 0 ? '' : _item$title,
        _item$img = item.img,
        img = _item$img === void 0 ? '' : _item$img,
        _item$previewImg = item.previewImg,
        previewImg = _item$previewImg === void 0 ? '' : _item$previewImg,
        _item$video = item.video,
        video = _item$video === void 0 ? '' : _item$video,
        _item$advantage = item.advantage,
        advantage = _item$advantage === void 0 ? [] : _item$advantage,
        _item$recommendTitle = item.recommendTitle,
        recommendTitle = _item$recommendTitle === void 0 ? '' : _item$recommendTitle,
        _item$recommendList = item.recommendList,
        recommendList = _item$recommendList === void 0 ? [] : _item$recommendList;
      const handleRecommend = recommendList.map((item, key) => {
        const text = item.text,
          href = item.href;
        const linkExtendProps = {
          'report-event': 'click_SceneVertical_recommend',
          'report-ext1': index1,
          'report-ext2': index,
          'report-ext3': key,
          target: '_blank'
        };
        return _objectSpread({
          text,
          href
        }, linkExtendProps);
      });
      return {
        tabTitle: tabTitle || '',
        tabDesc: tabDesc || '',
        title: title || '',
        img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
        previewImg: (0, _componentUtils.doComponentsUploadEvent)(previewImg || '').url,
        video: (0, _componentUtils.doComponentsUploadEvent)(video || '').url,
        advantage: !!advantage.length ? advantage.map((item, index) => ({
          title: item.title,
          desc: item.desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
            html: item.desc
          }) : ''
        })) : null,
        recommend: recommendTitle || !!recommendList.length ? {
          title: recommendTitle || '',
          items: !!recommendList.length ? handleRecommend : null
        } : null
      };
    });
    const handleBtns = btnList.map((item, index) => {
      const text = item.text,
        href = item.href;
      const buttonExtendProps = {
        'report-event': 'click_SceneVertical_button',
        'report-ext1': index1,
        'report-ext2': index,
        'report-ext3': text || '',
        target: '_blank'
      };
      if (index === 0) {
        return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
          href: href,
          align: "center",
          icon: true
        }, buttonExtendProps), text);
      }
      return /*#__PURE__*/React.createElement(_tpmProductIntl.Button, Object.assign({
        href: href,
        align: "center",
        icon: true,
        type: 'weak'
      }, buttonExtendProps), text);
    });
    return {
      text,
      itemsList: handleItems,
      btns: !!btnList.length ? handleBtns : null
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    tabList: handleTabList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmSceneVertic = formatTpmSceneVerticalData(data, {
        domains
      }),
      porintId = _formatTpmSceneVertic.porintId,
      tag = _formatTpmSceneVertic.tag,
      title = _formatTpmSceneVertic.title,
      desc = _formatTpmSceneVertic.desc,
      tabList = _formatTpmSceneVertic.tabList,
      bg = _formatTpmSceneVertic.bg;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmSceneVertical`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmSceneVertical', componentKey, title || ''])), tabList.length > 1 ? /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      className: "tpm-product-intl-scene3__section",
      title: title,
      tag: tag,
      desc: desc,
      bg: bg
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: tabList.map((item, index) => ({
        text: item.text,
        id: `id${index}`
      }))
    }, tabList.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: `id${index}`,
      key: index
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Scene3, {
      data: item.itemsList,
      btns: item.btns
    }))))) : tabList.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      className: "tpm-product-intl-scene3__section",
      bg: bg
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Scene3, {
      tag: tag,
      title: title,
      desc: desc,
      data: item.itemsList,
      btns: item.btns,
      key: index
    }))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}